import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { rxState } from '@rx-angular/state';
import { SubPage } from '../models/models';
import { Observable } from 'rxjs';
import { RxFor } from '@rx-angular/template/for';
import { RxLet } from '@rx-angular/template/let';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { leaveAnimation } from '../animations/leave.animation';
import { ScrollIntoViewIfActiveDirective } from '../scroll-in-view/scroll-into-view-if-active.directive';
import { IconComponent } from '../icons/icon/icon.component';
import { RxIf } from '@rx-angular/template/if';

@Component({
  selector: 'lib-thumbnails',
  standalone: true,
  imports: [
    CommonModule, 
    RxFor, 
    RxLet, 
    RxIf,
    RouterLink, 
    RouterLinkActive, 
    ScrollIntoViewIfActiveDirective,
    IconComponent
  ],
  templateUrl: './thumbnails.component.html',
  styleUrl: './thumbnails.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [leaveAnimation]
})
export class ThumbnailsComponent {
  
  public state = rxState<{ 
    index: number,
    thumbnails: SubPage[]
  }>();

  readonly thumbnails$ = this.state.select('thumbnails');
  readonly index$ = this.state.select('index');

  @Input()
  set index(index$: Observable<number>) {
    this.state.connect('index', index$);
  }

  @Input()
  set thumbnails(thumbnails: SubPage[]){
    this.state.set({
      thumbnails
    });
  }

  trackById = (index: number): number => index;
}
